import { render, staticRenderFns } from "./SaleWarning.vue?vue&type=template&id=0f17808a&scoped=true"
import script from "./SaleWarning.vue?vue&type=script&lang=js"
export * from "./SaleWarning.vue?vue&type=script&lang=js"
import style0 from "./SaleWarning.vue?vue&type=style&index=0&id=0f17808a&prod&lang=scss&scoped=true"
import style1 from "./SaleWarning.vue?vue&type=style&index=1&id=0f17808a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f17808a",
  null
  
)

export default component.exports